import React from 'react';
import SectionHeader from './SectionHeader';

const EXPERIENCES = [
  {
    company: 'Kaiburr',
    role: 'Software Engineer',
    period: 'Jan 2024 – Present',
    location: 'Remote',
    type: 'Full-time',
    gradient: 'linear-gradient(135deg, #8b5cf6, #3b82f6)',
    description:
      'Driving UI modernization by migrating legacy Primefaces (Java) modules to Next.js. Engineering high-performance data grids, architecting global state management with RBAC, and building custom data visualizations with Plotly.js.',
    tags: ['Next.js', 'TypeScript', 'React', 'Plotly.js', 'Python'],
  },
  {
    company: 'Lifelane Systems',
    role: 'Web Developer',
    period: 'Aug 2023 – Dec 2023',
    location: 'Remote',
    type: 'Freelance',
    gradient: 'linear-gradient(135deg, #06b6d4, #10b981)',
    description:
      'Architected a serverless admin panel with Next.js and Firebase. Built IoT device management modules and streamlined emergency reporting workflows with real-time React state updates.',
    tags: ['Next.js', 'Firebase', 'IoT', 'Serverless'],
  },
];

export default function Experience() {
  return (
    <section id="experience" style={{ padding: '7rem 0', position: 'relative' }}>
      {/* Background accent */}
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '-200px',
          width: '400px',
          height: '400px',
          borderRadius: '50%',
          background: 'var(--accent-violet)',
          filter: 'blur(120px)',
          opacity: 0.06,
          pointerEvents: 'none',
        }}
      />

      <div className="section-container">
        <SectionHeader
          label="Experience"
          title="Where I've Worked"
        />

        <div
          style={{
            marginTop: '3rem',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: '1.5rem',
          }}
        >
          {EXPERIENCES.map((exp, i) => (
            <div
              key={i}
              className="glass-card"
              style={{ padding: 0, overflow: 'hidden' }}
              id={`experience-card-${i}`}
            >
              {/* Gradient Top Bar */}
              <div style={{ height: '3px', background: exp.gradient }} />

              <div style={{ padding: '2rem' }}>
                {/* Role & Badge */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.35rem', flexWrap: 'wrap' }}>
                  <h3
                    style={{
                      fontFamily: 'var(--font-display)',
                      fontSize: '1.3rem',
                      fontWeight: 700,
                    }}
                  >
                    {exp.role}
                  </h3>
                  <span
                    style={{
                      padding: '0.2rem 0.65rem',
                      borderRadius: '999px',
                      fontSize: '0.7rem',
                      fontWeight: 600,
                      background: 'rgba(16, 185, 129, 0.1)',
                      color: '#10b981',
                      border: '1px solid rgba(16, 185, 129, 0.2)',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em',
                    }}
                  >
                    {exp.type}
                  </span>
                </div>

                {/* Company */}
                <p style={{ color: 'var(--accent-violet-light)', fontWeight: 600, fontSize: '1rem', marginBottom: '0.75rem' }}>
                  {exp.company}
                </p>

                {/* Period & Location */}
                <div style={{ display: 'flex', gap: '1.25rem', flexWrap: 'wrap', marginBottom: '1.25rem' }}>
                  <span
                    style={{
                      fontFamily: 'var(--font-mono)',
                      fontSize: '0.8rem',
                      color: 'var(--text-secondary)',
                    }}
                  >
                    {exp.period}
                  </span>
                  <span style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>📍 {exp.location}</span>
                </div>

                {/* Description */}
                <p style={{ color: 'var(--text-secondary)', lineHeight: 1.7, fontSize: '0.9rem', marginBottom: '1.25rem' }}>
                  {exp.description}
                </p>

                {/* Tags */}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
                  {exp.tags.map((tag) => (
                    <span
                      key={tag}
                      style={{
                        padding: '0.2rem 0.6rem',
                        borderRadius: '6px',
                        fontSize: '0.7rem',
                        fontWeight: 500,
                        fontFamily: 'var(--font-mono)',
                        background: 'rgba(139, 92, 246, 0.08)',
                        color: 'var(--accent-violet-light)',
                        border: '1px solid rgba(139, 92, 246, 0.12)',
                      }}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
